import { Maybe, Nullable } from '@mxt/zio/codec'

export const markupString = (rawString?: Nullable<string>) => (rawString ? rawString.replace(/\"/g, '').trim() : '')

export const mapCountry = (text: string) => (markupString(text) === 'VN' || 'VNM' ? 'Việt nam' : text)

export const isGoodString = (str: Maybe<string>) => !!str && true && str !== 'null' && str !== 'undefined'
export const markPhone84 = (str: string) => (str.match(/\+84/g)?.length ? str : `+84 ${str}`)
